<template>
<div class="chapter">
<div class="inner_page">
<p class="series-break" id="series"><a id="pII"></a><i>Published in cooperation with the</i> <br/>William P. Clements Center for Southwest Studies <br/>Southern Methodist University</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// series_page.vue?6cad6233